module.exports = __webpack_public_path__ + "static/media/menu_integracoes.3f48e4f5.png";